import styled from 'styled-components'

export const ButtonContainer = styled.button`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: var(--neutral-theme);
  padding: 16px 0;
  border-bottom: 1px solid var(--gray200);

  &:last-child:not(:only-child) {
    border-bottom: none;
  }
`

export const IconAndNameContainer = styled.section`
  display: flex;
  flex-direction: row;
  gap: 12px;
`
